import React from "react"

import OptimizedImage from "../../../../utils/OptimizedImage"
import {
  Cell,
  IconContent,
  IconText,
  IconWrapper,
} from "../../styles/TableCell.styled"

const PackageTableIcon = ({ icons }) => {
  return (
    <Cell verticalAlignTop={true}>
      <IconWrapper>
        {icons.map((icon) => {
          const noIconText =
            typeof icon.iconText === "undefined" ||
            icon.iconText === null ||
            icon.iconText === ""

          return (
            <IconContent key={icon?.iconImage?.id} centered={noIconText}>
              {icon.iconImage && (
                <OptimizedImage
                  src={icon?.iconImage?.url}
                  alt={icon?.iconImage?.alt}
                  image={icon?.iconImage?.gatsbyImageData}
                />
              )}
              {icon.iconText && <IconText>{icon.iconText}</IconText>}
            </IconContent>
          )
        })}
      </IconWrapper>
    </Cell>
  )
}

export default PackageTableIcon
